import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Company 
export const getOtherAppications = createAsyncThunk("/get-otherApplication-master", async (formData) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/get-otherApplication-master`, formData, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        return response;
    } catch (error) {
        console.error('Error fetching Companies - ', error);
        throw error;
    }
})


